function waitForEl(selector, callback) {
  if (document.querySelector(selector)) {
    callback();
  } else {
    setTimeout(function () {
      waitForEl(selector, callback);
    }, 100);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const details = document.querySelector('.product__section-details');
  const desktopAccord = document.querySelector('.desktop-accord');
  const mobileAccord = document.querySelector('.mobile-accord');
  const customField = document.querySelector('.custom-field.custom-field__level.custom-field__type--number');
  const title = document.querySelector('.product-title-with-icon');
  const loox = document.querySelector('.loox-cstm.desk-lox.var-rat');
  const trust = document.querySelector('.trust-badges-main');
  const completeYourOrder = document.querySelector('.complete-your-order');
  const thumbnails = document.getElementById('thumbnails');
  const prodRev = document.querySelector('.product-rev-cw');

  const isDesktop = () => window.innerWidth >= 1024;

  if (!details) return;

  if (trust.querySelector('.cw_new_trust_') == null && trust != null) {

    const wrapper = document.createElement('div');
    wrapper.className = 'cw_new_trust_';

    wrapper.innerHTML = `
    <div class="cw_new_trust_item" data-badge="shipping">
<svg xmlns="http://www.w3.org/2000/svg" width="29" height="21" viewBox="0 0 29 21" fill="none">
<path d="M22.0186 0.737122L20.8848 5.61558L20.7797 6.06758H24.2774L27.9573 10.9928L26.7811 16.9453H24.9973L25.0146 17.3311C25.0545 18.191 24.8078 18.9229 24.2703 19.5461L24.1587 19.6692C23.5449 20.3175 22.7895 20.6396 21.8674 20.6396C20.9455 20.6396 20.1918 20.3171 19.5811 19.6692C18.9692 19.0199 18.6862 18.2486 18.7288 17.3311L18.7468 16.9453H10.2548L10.272 17.3311C10.312 18.191 10.0652 18.9229 9.52773 19.5461L9.41613 19.6692C8.80232 20.3175 8.04692 20.6396 7.12485 20.6396C6.20299 20.6396 5.44928 20.3171 4.83857 19.6692C4.22661 19.0199 3.94362 18.2486 3.9863 17.3311L4.00429 16.9453H0.788705L0.877249 16.5486H4.1742L4.26199 16.3061C4.47141 15.7296 4.83393 15.2604 5.35906 14.893L5.35832 14.8922C5.87969 14.5277 6.46504 14.3459 7.12485 14.3459C7.70238 14.3459 8.22243 14.4856 8.69264 14.7649L8.89137 14.893C9.41819 15.2617 9.79148 15.7338 10.0193 16.3147L10.1115 16.5486H17.9801L18.0472 16.2643L18.0702 16.1657L18.5121 14.2854L18.5129 14.2833L21.4103 1.58438L21.5132 1.13377H7.97571L8.06424 0.737122H22.0186ZM7.12485 14.7425C6.38344 14.7425 5.73418 15.012 5.1949 15.5372C4.65023 16.0677 4.37499 16.7276 4.37499 17.4931C4.37507 18.2374 4.65296 18.8875 5.19129 19.4259C5.72983 19.9644 6.38027 20.2429 7.12485 20.2429C7.89028 20.2429 8.54949 19.9669 9.07993 19.4223C9.60513 18.8831 9.87455 18.2344 9.8747 17.4931L9.87175 17.3513C9.84057 16.6489 9.57506 16.0389 9.07705 15.5408C8.57905 15.0428 7.969 14.7767 7.26667 14.7454L7.12485 14.7425ZM21.8674 14.7425C21.126 14.7425 20.4767 15.012 19.9374 15.5372C19.3928 16.0677 19.1175 16.7276 19.1175 17.4931C19.1176 18.2374 19.3955 18.8875 19.9338 19.4259C20.4724 19.9644 21.1228 20.2429 21.8674 20.2429C22.5849 20.2429 23.2094 20.0006 23.7217 19.5216L23.8225 19.4223C24.3477 18.8831 24.6171 18.2344 24.6172 17.4931C24.6172 16.7784 24.3831 16.1545 23.9161 15.6416L23.8196 15.5408C23.3216 15.0428 22.7115 14.7767 22.0092 14.7454L21.8674 14.7425ZM20.5954 6.75002L19.2456 12.6189L19.142 13.0703H27.1561L27.2116 12.7673L27.4894 11.239L27.5182 11.0814L27.4225 10.9525L24.1904 6.61254L24.0795 6.46357H20.6616L20.5954 6.75002ZM3.55293 5.52845H5.68944L2.87195 10.3457V7.39935H0.736877L3.55293 2.58856V5.52845Z" fill="#243746"/>
<path d="M22.3885 0L21.1498 5.33064H24.3675L28.158 10.4039L28.2564 10.5352L28.2245 10.6958L26.9901 16.9456H25.2884C25.3325 17.8952 25.0567 18.7208 24.4548 19.4187L24.4496 19.4256L24.3373 19.5483L24.3321 19.5543C23.6469 20.2781 22.7939 20.6401 21.7735 20.6401C20.753 20.6401 19.9014 20.2772 19.2192 19.5535C18.5372 18.8297 18.2192 17.9603 18.2664 16.9456H10.5464L10.5507 17.1227C10.5545 17.9982 10.277 18.7645 9.7128 19.4187L9.70676 19.4256L9.59532 19.5483L9.58928 19.5543C8.904 20.278 8.05111 20.6401 7.03064 20.6401C6.01015 20.6401 5.15862 20.2773 4.47632 19.5535C3.79421 18.8297 3.47632 17.9604 3.52353 16.9456H0.234959L0.423272 16.0999L0.488059 15.8122H3.82154C4.00867 15.2971 4.30597 14.858 4.71214 14.4941L4.69228 14.4742L5.05249 14.222C5.63782 13.8126 6.29782 13.6086 7.03064 13.6086C7.59106 13.6086 8.10963 13.7282 8.58552 13.9689L8.78679 14.0794L8.79283 14.0829L8.79802 14.0872L8.9967 14.215L9.00274 14.2185L9.00879 14.2228C9.59342 14.632 10.0133 15.1616 10.2682 15.8114L17.5943 15.8122L17.6168 15.7138L18.059 13.8332L18.0634 13.8142L20.9572 1.1342H7.42195L7.61026 0.288516L7.67505 0H22.3885ZM7.02805 14.7428C6.38663 14.7435 5.83005 14.9736 5.35828 15.433C4.886 15.893 4.64918 16.4571 4.64908 17.1244C4.64915 17.7667 4.88535 18.3245 5.35742 18.7967C5.82999 19.2693 6.38819 19.5059 7.03064 19.5059C7.69777 19.5059 8.26173 19.2694 8.722 18.7967L8.88354 18.6153C9.23413 18.1854 9.41053 17.6912 9.41219 17.1322L9.40874 16.9905C9.37961 16.3832 9.15185 15.8629 8.722 15.433C8.28976 15.0009 7.76704 14.7727 7.15589 14.7454L7.02805 14.7428ZM21.7709 14.7428C21.1293 14.7434 20.5721 14.9734 20.1003 15.433C19.628 15.893 19.392 16.4571 19.3919 17.1244C19.392 17.7667 19.6281 18.3245 20.1003 18.7967C20.5728 19.2693 21.131 19.5059 21.7735 19.5059C22.4001 19.5059 22.9339 19.2972 23.3759 18.884L23.464 18.7959C23.9239 18.3235 24.154 17.7667 24.1542 17.1244C24.1541 16.5006 23.9538 15.9686 23.5555 15.528L23.4588 15.4278C23.0277 14.9995 22.507 14.7726 21.8987 14.7454L21.7709 14.7428ZM18.7777 13.9974L18.776 14.0008L18.7769 14.0017L18.3346 15.8814L18.3121 15.9798L18.3113 15.9807L18.2577 16.2087H18.7847C18.9305 15.7209 19.1988 15.2827 19.5863 14.9052C20.1924 14.3149 20.9333 14.006 21.7735 14.006H21.7804L21.9229 14.0086H21.9316C22.6256 14.0396 23.2461 14.2765 23.768 14.7126L23.9857 14.9121L23.9918 14.9173L24.0885 15.0184L24.1913 15.1359C24.4594 15.4586 24.649 15.8188 24.7632 16.2087H26.3837L27.0039 13.0705H18.9894L18.7777 13.9974ZM20.8604 6.46484L19.5103 12.3336H26.7551L27.0324 10.8047L23.8009 6.46484H20.8604ZM3.82759 4.79162H6.23765L2.4092 11.3377V7.39949H0L3.82759 0.86123V4.79162ZM1.28537 6.66265H3.14604V8.61662L4.95229 5.52845H3.08989V3.57967L1.28537 6.66265Z" fill="#243746"/>
</svg>
      <span>Fast Shipping</span>
    </div>

    <div class="cw_new_trust_item" data-badge="trial">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.4262 19.5558L13.2727 19.7076L10.2842 16.7471L9.58732 16.0558V19.6429C9.58732 22.2205 10.4568 24.4521 12.1865 26.3192L12.5438 26.6876C14.511 28.6274 16.9003 29.601 19.6885 29.601C20.1571 29.601 20.6261 29.5688 21.0952 29.5051L21.5644 29.4308C22.0961 29.3343 22.6027 29.2004 23.0846 29.0343L23.2604 29.2085C22.8576 29.362 22.4521 29.4896 22.0431 29.5898L21.7865 29.6498C21.1007 29.799 20.4012 29.8735 19.6885 29.8735C17.0141 29.8735 14.7059 28.9932 12.746 27.224L12.3584 26.8579C10.3173 24.8443 9.30438 22.4465 9.30438 19.6429V16.0502L8.60575 16.7479L5.64449 19.7068L5.49023 19.5542L9.44662 15.6122L13.4262 19.5558ZM19.5973 9.41223C22.2723 9.41223 24.5764 10.2889 26.5278 12.0499L26.9131 12.4143C28.9442 14.418 29.9543 16.8198 29.9543 19.6429V23.1533L30.6496 22.4691L33.6437 19.527L33.7876 19.6645L29.8128 23.604L25.8365 19.6645L26.0147 19.4943L28.9728 22.4508L29.6713 23.1485V19.6429C29.6713 16.8938 28.6819 14.5379 26.7148 12.5981C24.7482 10.6589 22.368 9.68478 19.5973 9.68478C19.1165 9.68478 18.6425 9.71498 18.1754 9.77513L17.7103 9.84544C17.1854 9.93629 16.6768 10.0618 16.1836 10.2187L16.0118 10.0428C16.4063 9.89209 16.8086 9.76916 17.2195 9.6752L17.4785 9.62004C18.1761 9.48155 18.8823 9.41223 19.5973 9.41223Z" fill="#243746" stroke="#243746" stroke-width="0.818452"/>
      </svg>
      <span>30-Day Home Trial</span>
    </div>

    <div class="cw_new_trust_item" data-badge="warranty">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_196_457)">
        <path d="M39.2857 -6.10352e-05H0V39.2857H39.2857V-6.10352e-05Z" fill="white"/>
        <path d="M12.0517 24.4846L12.3874 25.8529H12.4293L12.773 24.4846H14.1238L13.0228 27.3146V28.3718H11.7999V27.3146L10.7009 24.4846H12.0517ZM16.9573 26.9039H15.7423V27.3756H17.2409V28.3718H14.5194V24.4846H17.209L17.0571 25.4788H15.7423V26.0013H16.9573V26.9039ZM18.7556 28.3718H17.4727L18.4718 24.4846H20.3541L21.3532 28.3718H20.0524L19.9105 27.7619H18.9114L18.7696 28.3718H18.7556ZM19.367 25.678L19.1172 26.7657H19.6787L19.435 25.678H19.367ZM24.9918 28.3718H23.6531L23.1516 27.215H22.8898V28.3718H21.6669V24.4846H23.5911C24.4677 24.4846 24.906 24.9387 24.906 25.8467C24.906 26.4688 24.7061 26.8775 24.3365 27.0666L24.9979 28.3617L24.9918 28.3718ZM22.8898 25.4788V26.2554H23.1696C23.2786 26.2617 23.3878 26.2465 23.4912 26.2107C23.5269 26.1887 23.5554 26.1566 23.5731 26.1182C23.5909 26.0799 23.5972 26.0371 23.5911 25.9951V25.739C23.597 25.6974 23.5907 25.6549 23.5729 25.6169C23.5551 25.5789 23.5267 25.5471 23.4912 25.5255C23.388 25.4888 23.2787 25.4729 23.1696 25.4788H22.8898ZM25.3635 28.3068L25.5354 27.2902C25.8654 27.3799 26.205 27.4284 26.5465 27.4346C26.7888 27.4382 27.0311 27.4253 27.2718 27.396V27.0706L26.7203 27.0219C26.2248 26.9751 25.8831 26.8551 25.6973 26.658C25.4962 26.4145 25.3966 26.1008 25.4195 25.7837C25.4195 25.2531 25.5314 24.8891 25.7591 24.6879C25.987 24.4866 26.3587 24.391 26.9101 24.391C27.4039 24.3855 27.8966 24.4373 28.3788 24.5456L28.2249 25.5418C27.924 25.4868 27.6194 25.4555 27.3138 25.4482C27.1201 25.4463 26.9267 25.4565 26.7343 25.4788V25.7837L27.1739 25.8264C27.7067 25.8806 28.0757 26.0107 28.2809 26.2168C28.386 26.3305 28.4672 26.465 28.5194 26.6118C28.5716 26.7586 28.5938 26.9148 28.5846 27.0706C28.5904 27.296 28.5559 27.5206 28.4827 27.7334C28.4294 27.8853 28.345 28.024 28.2349 28.14C28.1199 28.2397 27.9827 28.3095 27.8353 28.3433C27.6848 28.3895 27.5302 28.4201 27.3737 28.4348C27.2419 28.4348 27.066 28.4491 26.8462 28.4491C26.3502 28.4533 25.8554 28.3994 25.3715 28.2885L25.3635 28.3068Z" fill="#243746"/>
        <path d="M14.326 7.77515C14.7403 7.77532 14.9494 8.04881 14.9494 8.22194V11.9833C14.9492 12.1642 14.7465 12.4301 14.3276 12.4301C13.9096 12.4301 13.7043 12.1589 13.7041 11.9833V8.20434C13.717 8.02589 13.9221 7.77515 14.326 7.77515ZM24.9179 7.77515C25.3328 7.77515 25.5397 8.04739 25.5397 8.22194V11.9833C25.5396 12.1647 25.3382 12.4301 24.9179 12.4301C24.4996 12.4301 24.2963 12.1603 24.296 11.9833V8.22194C24.296 8.0415 24.5002 7.77515 24.9179 7.77515ZM17.6653 9.97875H21.5066C21.5267 9.97867 21.5468 9.98276 21.5657 9.9907C21.5848 9.99872 21.6024 10.0112 21.6177 10.0267C21.6329 10.0422 21.6459 10.0607 21.6545 10.0819C21.6588 10.0926 21.6619 10.104 21.664 10.1154L21.6672 10.1498V10.1514C21.6672 10.2223 21.6332 10.3466 21.5657 10.4511C21.5341 10.5 21.5053 10.5283 21.4874 10.5414C21.4866 10.542 21.4857 10.5425 21.485 10.543H17.6853C17.6846 10.5426 17.6837 10.5419 17.6829 10.5414C17.6647 10.5281 17.6355 10.4993 17.6038 10.4503C17.5359 10.3456 17.5023 10.2216 17.5023 10.1514L17.5055 10.1162C17.5077 10.1048 17.5115 10.0933 17.5159 10.0826C17.5246 10.0613 17.5372 10.0423 17.5526 10.0267C17.568 10.0111 17.5862 9.99872 17.6053 9.9907L17.6653 9.97875ZM20.5858 16.1859L20.2317 16.1379C19.9675 16.1018 19.7014 16.081 19.4349 16.0764L19.1679 16.0772H19.1671C18.7041 16.0883 18.243 16.1376 17.7884 16.225L17.6413 15.3066C18.2842 15.1119 18.9511 15.0096 19.6227 15.003H19.6291L19.6347 15.0022C20.0874 14.9842 20.5408 15.0259 20.9831 15.126C21.1638 15.1747 21.3333 15.2601 21.4819 15.377C21.6834 15.5707 21.8191 15.8924 21.8191 16.4192C21.8191 17.0638 21.5898 17.4635 21.1669 17.7108L20.9639 17.8292V18.383L21.2021 18.4925C21.4769 18.6192 21.6647 18.7878 21.7871 18.9921C21.911 19.1989 21.9847 19.4699 21.9854 19.825H21.9845L21.9854 19.8354C21.9911 20.0614 21.965 20.2867 21.9079 20.5043L21.8399 20.7186C21.7708 20.9085 21.66 21.08 21.5178 21.2197C21.3656 21.3492 21.1894 21.4448 20.9999 21.501C20.5305 21.6222 20.0489 21.6861 19.5652 21.6905L19.3558 21.6888L19.3454 21.688L19.0696 21.684C18.5497 21.6668 18.0325 21.6007 17.5238 21.4898L17.6909 20.4156C18.0475 20.4959 18.4099 20.5483 18.7747 20.5722L18.9977 20.5834H19.0081C19.4157 20.587 19.8233 20.5632 20.2277 20.5115L20.5858 20.4652V18.9961L20.223 18.9546L18.8107 18.7923V17.8747L20.2286 17.6933L20.5858 17.6477V16.1859ZM28.2045 10.1658C28.2045 10.1426 28.2088 10.1197 28.2173 10.0987C28.2259 10.0774 28.2387 10.0582 28.2541 10.0427C28.2693 10.0272 28.287 10.0155 28.306 10.0075L28.3651 9.99553H30.2442L30.3673 10.0027C30.6533 10.0333 30.9229 10.1624 31.1298 10.3728C31.3657 10.6128 31.5015 10.9392 31.5047 11.2816L31.5039 30.2323C31.5007 30.5745 31.3657 30.901 31.1298 31.141C30.8935 31.3813 30.5752 31.5158 30.2442 31.5183H9.03556C8.70352 31.5158 8.38416 31.3803 8.14761 31.1386C7.94042 30.9268 7.81107 30.6484 7.78154 30.3513L7.77515 30.2227V11.2744C7.77542 11.1049 7.80856 10.9371 7.87266 10.7812C7.92075 10.6643 7.98562 10.5558 8.06449 10.4591L8.14761 10.3664L8.15001 10.364C8.356 10.1534 8.62535 10.0241 8.91091 9.99389L9.03401 9.98751H11.0498C11.0699 9.98742 11.0907 9.99078 11.1097 9.99872C11.1287 10.0067 11.1464 10.0192 11.1617 10.0346C11.1767 10.0501 11.1891 10.0688 11.1976 10.0898C11.2019 10.1005 11.205 10.112 11.2072 10.1234L11.2112 10.1577V10.1594C11.2112 10.2303 11.1771 10.3546 11.1097 10.4591C11.078 10.5082 11.0493 10.5372 11.0314 10.5502L11.0298 10.551H9.25057C9.03425 10.5506 8.82588 10.6248 8.65916 10.7588L8.59041 10.8204L8.58484 10.8259C8.49743 10.9147 8.42868 11.0199 8.3826 11.1353C8.34798 11.2221 8.32646 11.3136 8.31868 11.4062L8.31549 11.4934V29.5849H8.30902L8.30747 29.9933C8.3069 30.2097 8.37933 30.4198 8.5129 30.5887L8.57363 30.6583L8.57682 30.6614C8.66439 30.7506 8.76932 30.8211 8.88529 30.8684C8.99865 30.9147 9.12019 30.9365 9.24263 30.9348V30.9364H30.0228C30.2395 30.937 30.4481 30.8621 30.6143 30.727L30.6831 30.6655L30.6862 30.6614C30.774 30.5722 30.8435 30.4659 30.8892 30.3497C30.9235 30.2626 30.9445 30.171 30.9516 30.078L30.954 29.9852V11.4934C30.9545 11.3725 30.9319 11.2524 30.8869 11.1401C30.8413 11.0267 30.7734 10.923 30.6878 10.8356C30.6023 10.7482 30.5003 10.6784 30.3873 10.631C30.2748 10.5837 30.1538 10.5588 30.0317 10.559H28.3851L28.3843 10.5582C28.3664 10.5452 28.3377 10.5162 28.306 10.4671C28.2385 10.3625 28.2045 10.2383 28.2045 10.1674V10.1658Z" fill="#243746" stroke="#243746" stroke-width="0.818452"/>
        </g>
        <defs>
        <clipPath id="clip0_196_457">
        <rect width="39.2857" height="39.2857" fill="white"/>
        </clipPath>
        </defs>
      </svg>
      <span>3-Year Warranty</span>
    </div>
  `;
    // trust-badges.liquid lists the icons to hide in data-hide-icons, from
    // Theme settings > Product page icons; the rest stay. With all three
    // hidden, the row goes too, so it leaves no gap.
    const hideIcons = (trust.getAttribute('data-hide-icons') || '').split(' ').filter(Boolean);
    hideIcons.forEach(name => {
      const item = wrapper.querySelector('[data-badge="' + name + '"]');
      if (item) item.remove();
    });
    if (!wrapper.children.length) trust.style.display = 'none';
    trust.innerHTML = '';
    trust.appendChild(wrapper);
  }

  // Runs before the isDesktop() block: on desktop its customField line throws
  // where there is no .after-feature (Bamton 2026, whose product info
  // accordion replaced that section), and the title was never moved out of
  // its hidden .product__section-title.
  // With no reviews there is no rating link to sit under: main-product.liquid
  // only renders it when loox.num_reviews > 0 (the open-box products). The
  // title then takes the rating's place, just above its hidden wrapper.
  const titleWrap = title && title.closest('.product__section-title');
  if (title && loox && loox.parentNode) {
    loox.parentNode.insertBefore(title, loox.nextSibling);
  } else if (title && titleWrap && titleWrap.parentNode) {
    titleWrap.parentNode.insertBefore(title, titleWrap);
  }

  if (isDesktop()) {
    // if (desktopAccord) details.appendChild(desktopAccord);
    if (customField) document.querySelector('.after-feature').appendChild(customField);
    // if (trust)       details.appendChild(trust);
  } else {
    // if (mobileAccord) details.appendChild(mobileAccord);
    if (customField) document.querySelector('.mobile-accord').appendChild(customField);
    // if (trust)             details.appendChild(trust);
    if (prodRev) details.appendChild(prodRev);
  }

  document.querySelectorAll('.product-rec-card').forEach(card => {
    if (card.classList.contains('cw-cart-ready')) return;
    card.classList.add('cw-cart-ready');

    const productUrl = card.getAttribute('data-product-url');
    if (!productUrl) return;

    const addBtn = document.createElement('button');
    addBtn.className = 'cw-add-btn';
    addBtn.textContent = '+ Add';

    addBtn.addEventListener('click', async () => {
      addBtn.disabled = true;
      //   addBtn.textContent = 'ADDING...';

      try {
        const res = await fetch(productUrl + '.js');
        const product = await res.json();

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: card.querySelector('.offer_select') != null ? card.querySelector('.offer_select').value : product.variants[0].id,
            quantity: 1
          })
        });

        // addBtn.textContent = 'ADDED ✓';
        setTimeout(function () {
          // addBtn.textContent = '+ Add';
          addBtn.disabled = false;
        }, 1500);

        Shopify.theme.ajaxCart.init();
        document
          .querySelector('.js-mini-cart-trigger').dispatchEvent(new Event('click', { bubbles: true }));

      } catch (e) {
        addBtn.textContent = '+ Add';
      } finally {
        addBtn.disabled = false;
      }
    });

    addBtn.addEventListener('click', () => {
      const checkbox = card.querySelector('input[type="checkbox"]');
      if (checkbox) {
        if (addBtn.classList.contains("added_checked")) {
          checkbox.checked = false;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          addBtn.textContent = '+ Add';
          addBtn.classList.remove("added_checked");
        } else {
          checkbox.checked = true;
          // addBtn.textContent = 'REMOVE';
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          addBtn.classList.add("added_checked");
        }
      }
    });

    card.appendChild(addBtn);

    // var checkbox_1 = card.querySelector('.checkbox-wrapper');
    // if (checkbox_1) checkbox_1.style.display='none';
  });


  setInterval(function () {
    waitForEl(".product-rec-card .loox-rating", function () {
      document.querySelectorAll('.product-rec-card .loox-rating').forEach(rating => {
        if (rating.classList.contains('cw-one-star')) return;
        rating.classList.add('cw-one-star');

        const ratingValue = rating.getAttribute('data-rating') || '5.0';
        const reviews = rating.getAttribute('data-raters') || '0';

        const content = rating.querySelector('.loox-rating-content');
        if (!content) return;

        content.innerHTML = `
      <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 3.87489C11 3.9675 10.9427 4.06841 10.8281 4.17762L8.42829 6.40776L8.99662 9.55834C9.00121 9.58761 9.0035 9.62999 9.0035 9.68459C9.00613 9.76415 8.98187 9.84241 8.93429 9.90782C8.91139 9.93795 8.88093 9.96213 8.84571 9.97815C8.81048 9.99417 8.7716 10.0015 8.73263 9.99956C8.64875 9.99956 8.56075 9.97423 8.46817 9.92355L5.5 8.43738L2.53183 9.92443C2.43467 9.97466 2.34667 10 2.26737 10C2.17479 10 2.10558 9.96942 2.05929 9.90826C2.01155 9.8429 1.98713 9.76464 1.98963 9.68503C1.98963 9.65969 1.99421 9.61775 2.00338 9.55878L2.57171 6.40863L0.165458 4.17806C0.055 4.06404 0 3.96357 0 3.87489C0 3.7198 0.12375 3.62282 0.370333 3.58525L3.68867 3.12525L5.17596 0.258617C5.25983 0.08606 5.36754 0 5.5 0C5.63246 0 5.74017 0.08606 5.82404 0.258617L7.31133 3.12525L10.6297 3.58525C10.8767 3.62282 11 3.7198 11 3.87489Z" fill="#EDC170"/>
</svg>
      <span class="cw-rating-text">${ratingValue} (${reviews} Reviews)</span>
    `;
      });
    });
  }, 5000);

  setInterval(function () {
    const cards = document.querySelectorAll(".product-rec-card");
    if (cards.length) {
      cards.forEach((card) => {
        const wrapper = card.querySelector(".checkbox-wrapper");
        if (wrapper) wrapper.style.display = "none";
        const checkbox = card.querySelector('input[type="checkbox"]');

        const addBtn = card.querySelector('.cw-add-btn');

        if (checkbox && addBtn) {
          if (checkbox.checked) {
            addBtn.classList.add('added_checked');
          } else {
            addBtn.textContent = '+ Add';
            addBtn.classList.remove('added_checked');
          }
        }
      });
    }

    waitForEl(".qbk-offer__body .qbk-offer__checkbox input", function () {
      const cardsInner = document.querySelectorAll(".product-rec-card");
      if (cardsInner.length) {
        cardsInner.forEach((card) => {
          const wrapper = card.querySelector(".checkbox-wrapper");
          if (wrapper) wrapper.style.display = "inline-block";
        });
      }
    });
  }, 5000);

  waitForEl(".qbk-offer__body .qbk-offer__checkbox input", function () {
    const cards = document.querySelectorAll(".product-rec-card");
    if (!cards.length) return;

    const addToCartBtn = document.querySelector(".AddtoCart.js-ajax-submit");
    if (addToCartBtn) {
      addToCartBtn.addEventListener("click", function () {
        document.querySelectorAll(".product-rec-card").forEach((card) => {
          const addToCartCustomCheckbox = card.querySelector(
            ".checkbox-wrapper input[type='checkbox']"
          );
          if (addToCartCustomCheckbox) {
            addToCartCustomCheckbox.checked = false;
          }
        });
      });
    }

    cards.forEach((card) => {
      const customCheckbox = card.querySelector(
        ".checkbox-wrapper input[type='checkbox']"
      );
      const checkboxWrapper = card.querySelector(".checkbox-wrapper");
      const productImage = card.querySelector(".product-rec-image");
      const info = card.querySelector(".product-rec-info");
      const productUrl = card.getAttribute("data-product-url");
      const selector = card.querySelector(".offer_select") || null;

      if (checkboxWrapper) {
        checkboxWrapper.style.display = "inline-block";
      }

      if (!customCheckbox) return;

      const customCheckboxValue = customCheckbox.value;
      if (!customCheckboxValue) return;

      function toggleCustomCheckbox() {
        customCheckbox.checked = !customCheckbox.checked;
        customCheckbox.dispatchEvent(new Event("change", { bubbles: true }));
      }

      if (checkboxWrapper) {
        checkboxWrapper.addEventListener("click", function (e) {
          if (e.target.tagName.toLowerCase() === "input") return;
          e.preventDefault();
          e.stopPropagation();
          toggleCustomCheckbox();
        });
      }

      if (selector) {
        selector.addEventListener("change", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const selectedOption = selector.options[selector.selectedIndex];

          const imgUrl = selectedOption.getAttribute("data-img");
          const card = selector.closest(".product-rec-card");
          const cardImg = card.querySelector(".product-rec-image");

          if (imgUrl && cardImg) {
            cardImg.src = imgUrl;
            cardImg.srcset = imgUrl;
          }

          const offerWrapper = document.querySelector(".qbk-offer-list--transition");
          if (!offerWrapper) return;

          const offerSelect = offerWrapper.querySelector(
            ".qbk-offer__variant"
          );

          if (!offerSelect) return;
          const matchOption = [...offerSelect.options].find(opt =>
            opt.text.trim().toLowerCase() === selectedOption.text.trim().toLowerCase()
          );

          if (matchOption) {
            offerSelect.value = matchOption.value;
            offerSelect.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      }

      if (productImage) {
        productImage.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggleCustomCheckbox();
        });
      }

      if (info && productUrl) {
        info.addEventListener("click", function (e) {
          if (e.target.closest("select")) {
            const selectedOption = selector.options[selector.selectedIndex];

            const imgUrl = selectedOption.getAttribute("data-img");
            const card = selector.closest(".product-rec-card");
            const cardImg = card.querySelector(".product-rec-image");

            if (imgUrl && cardImg) {
              cardImg.src = imgUrl;
              cardImg.srcset = imgUrl;
            }

            const offerWrapper = document.querySelector(".qbk-offer-list--transition");
            if (!offerWrapper) return;

            const offerSelect = offerWrapper.querySelector(
              ".qbk-offer__variant"
            );


            if (!offerSelect) return;
            const matchOption = [...offerSelect.options].find(opt =>
              opt.text.trim().toLowerCase() === selectedOption.text.trim().toLowerCase()
            );

            console.log(offerSelect, "   offerSelect ", matchOption);

            if (matchOption) {
              offerSelect.focus();
              offerSelect.selectedIndex = [...offerSelect.options].indexOf(matchOption);

              offerSelect.dispatchEvent(
                new Event("mousedown", { bubbles: true })
              );
              offerSelect.dispatchEvent(
                new Event("mouseup", { bubbles: true })
              );
              offerSelect.dispatchEvent(
                new Event("change", { bubbles: true })
              );
            }
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }, true);
      }

      card.addEventListener("click", function (e) {
        const target = e.target;

        const clickedInWrapper = checkboxWrapper && checkboxWrapper.contains(target);
        const clickedInImage = productImage && productImage.contains(target);
        const clickedInInfo = info && info.contains(target);

        if (!clickedInWrapper && !clickedInImage && !clickedInInfo) {
          e.preventDefault();
        }
      });

      customCheckbox.addEventListener("change", function () {
        document
          .querySelectorAll(".qbk-offer-list--transition .qbk-bogo__offers")
          .forEach((offer) => {
            const offerCheckbox = offer.querySelector(
              ".qbk-offer__body .qbk-offer__checkbox input"
            );
            if (!offerCheckbox) return;

            const clickOfferId = offerCheckbox.getAttribute("id");
            if (clickOfferId && clickOfferId.includes(customCheckboxValue)) {
              const label = offerCheckbox.nextElementSibling;
              if (label && label.tagName.toLowerCase() === "label") {
                label.click();
              }
            }
          });
      });

      document
        .querySelectorAll(".qbk-offer-list--transition .qbk-bogo__offers")
        .forEach((offer) => {
          const offerCheckbox = offer.querySelector(
            ".qbk-offer__body .qbk-offer__checkbox input"
          );
          if (!offerCheckbox) return;

          const offerId = offerCheckbox.getAttribute("id");
          if (offerId && offerId.includes(customCheckboxValue)) {
            const priceEl = offer.querySelector(
              ".qbk-offer__body .qbk-offer__contents .qbk-offer__price"
            );
            if (priceEl) {
              const cardPrice = card.querySelector(".product-rec-price");
              if (cardPrice) {
                cardPrice.innerHTML = priceEl.innerHTML;
              }
            }
          }
        });


    });
  });
});

(function () {
  function findNavEls(swiperEl) {
    // Most Shopify themes wrap sections in .shopify-section
    const scope =
      swiperEl.closest(".shopify-section") ||
      swiperEl.closest("section") ||
      swiperEl.parentElement ||
      document;

    const prev = scope.querySelector(".swiper-button-prev");
    const next = scope.querySelector(".swiper-button-next");

    return { prev, next };
  }

  function initMobileSwiper() {
    document.querySelectorAll(".swiper.mobile-only").forEach((el) => {
      const isMobile = window.matchMedia("(max-width: 767px)").matches;

      // If Swiper exists, nuke it so we can rebind navigation correctly
      if (el.swiper) {
        el.swiper.destroy(true, true);
      }

      if (!isMobile) return;

      const { prev, next } = findNavEls(el);

      const sw = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 16,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,

        navigation:
          prev && next
            ? {
              prevEl: prev,
              nextEl: next,
            }
            : false,
      });

      // Force nav to initialize (important when DOM is dynamic)
      if (prev && next) {
        sw.navigation.init();
        sw.navigation.update();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", initMobileSwiper);
  window.addEventListener("resize", initMobileSwiper);
})();


document.addEventListener('click', function (e) {
  if (e.target.classList.contains('readmore')) {
    const wrapper = e.target.closest('.detail-sec-ad');
    if (!wrapper) return;

    const shortPanel = wrapper.querySelector('.pd-short');
    const longPanel = wrapper.querySelector('.pd-long');

    if (shortPanel) shortPanel.style.display = 'none';
    if (longPanel) longPanel.style.display = 'block';
  }

  if (e.target.classList.contains('readless')) {
    const wrapper = e.target.closest('.detail-sec-ad');
    if (!wrapper) return;

    const shortPanel = wrapper.querySelector('.pd-short');
    const longPanel = wrapper.querySelector('.pd-long');

    if (longPanel) longPanel.style.display = 'none';
    if (shortPanel) shortPanel.style.display = 'block';
  }
});

function moveDeliveryNoteOnMobile() {
  if (window.innerWidth <= 768) {
    const note = document.querySelector('.adel-del-note');
    const inventoryTitle = document.querySelector('.adel-invenntry-app > strong');

    if (note && inventoryTitle && !inventoryTitle.nextElementSibling?.classList.contains('adel-del-note')) {
      inventoryTitle.appendChild(note);
    }
  }
}

document.addEventListener('DOMContentLoaded', moveDeliveryNoteOnMobile);
window.addEventListener('resize', moveDeliveryNoteOnMobile);
